import { motion } from 'framer-motion';
import { revealUp } from '../lib/anim';
import { SERVICES } from '../data/portfolio';

export default function Services() {
  return (
    <section
      id="services"
      className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="mb-16 grid grid-cols-1 gap-6 md:grid-cols-12">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground md:col-span-4">
          (Capabilities)
        </span>
        <h2 className="font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-foreground md:col-span-8 md:text-6xl">
          What I do, and how I think about it.
        </h2>
      </div>

      <div className="border-t border-border">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.id}
            variants={revealUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.4 }}
            custom={i}
            className="group grid grid-cols-1 items-center gap-4 border-b border-border py-8 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-12 md:gap-8 md:py-10"
          >
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground md:col-span-2">
              0{i + 1}
            </span>
            <h3 className="font-display text-3xl font-medium tracking-tight text-foreground transition-transform duration-500 group-hover:translate-x-2 md:col-span-4 md:text-4xl">
              {s.title}
            </h3>
            <p className="text-base leading-relaxed text-muted-foreground md:col-span-5">
              {s.body}
            </p>
            <span className="justify-self-start rounded-full border border-border px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground md:col-span-1 md:justify-self-end">
              {s.tag}
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
